export interface ISiteItems {
  topography_type: string[];
  condition_type: string[];
}

export const getSiteDetails = (): ISiteItems => ({
  topography_type: [
    'Flat',
    'Flat and Moderate Slope',
    'Flat to slope',
    'Generally Level',
    'Gentle Incline',
    'Gentle Slope',
    'Level',
    'Level, Graded and Ready for Construction',
    'Mild Slope',
    'Moderate',
    'Moderate slope',
    'Rolling',
    'Slight rise',
    'Slight slope',
    'Slightly rolling',
    'Slope',
    'Slope to Rear',
    'Slopes Upward',
    'Sloping and Level',
    'Steep',
  ],
  condition_type: [
    'Excellent',
    'Good',
    'New',
    'Newly Renovated',
    'Other',
    'Partially Restored',
    'Poor',
    'Very good',
  ],
})
